import type { ViewContext, ContextRegistration } from '../types/context'

/**
 * Collects view contexts registered by various parts of the host app.
 * Components call register() to contribute their context, and the
 * CompanionManager calls getAll() when assembling the prompt.
 */
export class ContextCollector {
  private registry = new Map<string, ViewContext>()

  /** Register or update a context. Key is used for dedup. */
  register(key: string, context: ViewContext): void {
    this.registry.set(key, context)
  }

  /** Remove a previously registered context */
  unregister(key: string): void {
    this.registry.delete(key)
  }

  /** Get all currently registered contexts */
  getAll(): ViewContext[] {
    return Array.from(this.registry.values())
  }

  /** Get all registrations with their keys */
  getEntries(): ContextRegistration[] {
    return Array.from(this.registry.entries()).map(([key, context]) => ({
      key,
      context,
    }))
  }

  /** Clear all registered contexts */
  clear(): void {
    this.registry.clear()
  }
}
